import { Flex, Stack, Text, useMantineTheme } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import classes from './AfaComunicacionsCard.module.css';

export interface AfaComunicacionsCardProps {
  /**
   * Título de la comunicación
   */
  title: string;
  /**
   * Descripción de la comunicación
   */
  description: string;
  /**
   * Fecha de la comunicación (string en formato DD/MM/YYYY)
   */
  data: string;
  /**
   * Callback cuando el card es clicado
   */
  onClick?: () => void;
}

const AfaComunicacionsCard = ({ 
  title, 
  description,
  data,
  onClick 
}: AfaComunicacionsCardProps) => {
  const theme = useMantineTheme();

  return (
    <div 
      className={classes.card} 
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <Flex justify="space-between" align="center" gap="md">
        {/* Lado izquierdo: Título, descripción y fecha */}
        <Stack gap={4} style={{ flex: 1 }}>
          <Text size="md" fw={600} c="brand.5">
            {title}
          </Text>
          <Text size="sm" c={theme.other.black}>
            {description}
          </Text>
          <Text size="sm" c={theme.other.black}>
            {data}
          </Text>
        </Stack>

        {/* Lado derecho: Icono chevron */}
        <IconChevronRight 
          size={20} 
          color={theme.other.black} 
          style={{ flexShrink: 0 }}
        />
      </Flex>
    </div>
  );
};

export default AfaComunicacionsCard;
